import React, { useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom"; // For linking to the "Add New Project" page
import {
  getProjectRequests,
  setProjectsSize,
  unsetProjects,
} from "../../features/projectsSlice"; // Redux action to fetch ongoing projects
import Loading from "../../components/loading/Loading";
import PageTitle from "../../components/titles/PageTitle";
import SecondContainer from "../../components/container/SecondContainer";
import { useAuthorization } from "../../hooks/useAuthorization";
import PaginationSecondBar from "../../components/pagination/PaginationSecondBar";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const MyRequest = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const total = useSelector((state) => state.projects.total);
  const projects = useSelector((state) => state.projects.data);
  const user = useSelector((state) => state.user.userInfo);
  const loading = useSelector(
    (state) => state.projects.load.getProjectRequests
  );

  //
  const onPageChange = async (limit, offset) => {
    try {
      let res;
      if (user.id && user.communities.length <= 0) {
      } else if (user.province_id) {
        res = await dispatch(
          getProjectRequests({
            desk: "volunteer",
            id: user.province_id,
            community_id: user.communities[0].id,
            limit,
            offset,
          })
        );
      }
      delete res.data.data;
      return res.data;
    } catch (error) {}
  };

  // Fetch ongoing projects when the component mounts
  useLayoutEffect(() => {
    if (user.id && user.communities.length <= 0) {
    } else if (user.province_id) {
      dispatch(
        getProjectRequests({
          desk: "volunteer",
          id: user.province_id,
          community_id: user.communities[0].id,
        })
      );
    }

    return () => {
      dispatch(unsetProjects());
    };
  }, [user]);

  // useEffect(() => {}, [loading, prevCount, total, pageSize, nextCount]);

  // if (loading === loadStatus.loading) {
  //   return <Loading />;
  // }

  if (loading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <SecondContainer className=" ">
      {/* Basic Instructions */}
      {/* <h1 className="text-2xl text font-bold mb-4">Ongoing Applications</h1> */}
      <PageTitle title="Applications" />
      {/* <p className="mb-4 text-text-1/65">
        Below is a list of all ongoing applications. You can view the details of
        each project, see the current step, and continue your application. To
        start a new application, click the "New Application" button.
      </p> */}

      {user.id && user.communities.length > 0 ? (
        <>
          {/* New Application Button */}

          <div className="flex justify-end mb-6">
            {isAuthorized("projects", "update") && (
              <Link
                to="/requests/beneficiary-profile"
                className={
                  isAuthorized("projects", "update")
                    ? "px-4 py-2 bg-primary text-text-gen rounded-md hover:bg-primary/75"
                    : "px-4 py-2 bg-slate-500 text-text-gen rounded-md"
                }
              >
                <button>New Application</button>
              </Link>
            )}
          </div>

          {/* Ongoing Applications Table */}
          {
            <>
              {/* <PaginationBar
                
              /> */}
              <PaginationSecondBar
                onPageChange={onPageChange}
                loading={loading}
                total={total}
                totalPages={total}
              />

              <div className="table-container">
                <table className="app-table">
                  <thead className=" app-thead">
                    <tr>
                      <th className="app-thead-th">Num</th>
                      <th className="app-thead-th">Title</th>
                      <th className="app-thead-th">Date Started</th>
                      <th className="app-thead-th">Status</th>
                      <th className="app-thead-th">Level </th>
                      {isAuthorized("projects", "update") && (
                        <th className="app-thead-th">Action</th>
                      )}
                    </tr>
                  </thead>
                  {loading ? (
                    <tr className="!border-none !bg-transparent">
                      <td
                        colSpan={6}
                        className="!border-none !border-transparent "
                      >
                        <div className="h-72 flex items-center justify-center mx-auto w-fit !border-none">
                          <Loading />
                        </div>
                      </td>
                    </tr>
                  ) : projects.length > 0 ? (
                    // </tr>
                    <tbody className="text-text-1/85">
                      {projects.map((project, index) => (
                        <tr key={project.id}>
                          {/* Project Num */}
                          <td className="table-data !text-sm">{++index}</td>
                          {/* Project Title */}
                          <td className="table-data !text-base">
                            {project.name.length >= 30
                              ? project.name.slice(0, 35) + "....."
                              : project.name}
                          </td>

                          {/* Date Started */}
                          <td className="table-data !text-sm">
                            {new Date(project.updated_at).toDateString()}
                          </td>

                          {/* Stage Reached (Assumed it's available in the project object) */}
                          <td className="table-data !text-sm">
                            {project.stage.name || "Not Started"}
                          </td>

                          {/* Step Reached (Assumed it's available in the project object) */}
                          <td className="table-data !text-sm">
                            {project.stage.step || "Not Started"}
                          </td>

                          {/* Continue Application Button */}
                          {isAuthorized("projects", "update") && (
                            <td className="table-data !text-sm text-center">
                              <>
                                {project.stage?.desk === "volunteer" ? (
                                  <Link to={project.stage.url}>
                                    <button className="px-4 py-2 bg-green-500/80 text-white rounded hover:bg-green-600">
                                      Cont.. Application
                                    </button>
                                  </Link>
                                ) : project.stage.desk === "proposal" ? (
                                  <p className="inline-block px-4 py-2 bg-slate-500 text-white rounded ">
                                    Proposal Develop
                                  </p>
                                ) : project.stage.desk === "pdo" ? (
                                  <p className="inline-block px-4 py-2 bg-slate-400 text-white rounded ">
                                    Pending Confirm..
                                  </p>
                                ) : (
                                  <p className="inline-block px-4 py-2 bg-slate-400 text-white rounded ">
                                    Pending Approval
                                  </p>
                                )}
                              </>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <>
                      <tr className="!border-none !bg-transparent">
                        <td
                          colSpan={6}
                          className="!border-none !border-transparent "
                        >
                          <div className="flex flex-col items-center justify-center gap-3 w-full h-72 border border-bkg2 rounded-md">
                            <p className="text-text-1/60 font-medium text-xl">
                              There are no Requests to be worked on.
                            </p>
                            <p className="text-text-1/60 font-medium text-xl">
                              Please click on New Application above to begin a
                              new Request.
                            </p>
                          </div>
                        </td>
                      </tr>
                    </>
                  )}
                </table>
              </div>
            </>
          }
        </>
      ) : (
        <>
          <div className="flex flex-col items-center justify-center gap-3 w-full h-72 border border-bkg2 rounded-md">
            <p className="text-text-1/60 font-medium text-xl">
              You are not part of any Community.
            </p>
            <p className="text-text-1/60 font-medium text-xl">
              Please Contact your Administator.{" "}
            </p>
          </div>
        </>
      )}
    </SecondContainer>
  );
};

export default MyRequest;

// : (
// )
